module.exports = __webpack_public_path__ + "assets/img/16.fd085c72.png";